import React, {useState, useEffect} from 'react';
import queryString from 'query-string';
import {withRouter} from "react-router-dom";
import LoadingIndicator from "../../../../meta/LoadingIndicator";
import {saveUserActivationData} from "../../../../../slices/userSlice";
import {connect} from "react-redux";
import {withToastManager} from "react-toast-notifications";
import AuthenticationService from "../../../../../services/Authentication/AuthenticationService";
import TermsAndPrivacyModal from "../../../modals/TermsAndPrivacyModal";

function FacebookAuthComponent(props) {
    const {toastManager, history} = props;
    const urlParams = queryString.parse(props.location.search);

    const [ state, setState ] = useState( {fbToken: urlParams.fbToken, loading: true, modalShown: false, userId: null, alreadyRegistered: false});

    useEffect(() => {
        handleFacebookAuthentication();
    }, []);

    function closeAgreementModal() {
        setState({...state, modalShown: false});
        history.goBack();
    }

    function handleFacebookAuthentication() {
        AuthenticationService.defaultLogin(null, null, state.fbToken, null,
            (response) => {
                if (response.data.user_agrees_contact) {
                    props.saveUserActivationData(response.data.user_id, response.data.token, response.data.level);
                    history.push("/surveys");
                }
                else {
                    setState({...state, alreadyRegistered: true, userId: response.data.user_id, modalShown: true});
                }
            },
            (error) => {
                if (error.data.code && error.data.code === window.bubblyWebsiteConfig.CODE_USER_NON_EXISTENT) {
                    setState({...state, alreadyRegistered: false, modalShown: true});
                }
                else if (error.data.code && error.data.code === window.bubblyWebsiteConfig.CODE_USER_NOT_ACTIVE) {
                    toastManager.add("Inactive user!", {
                        appearance: 'error'
                    });
                    AuthenticationService.goBackAfterTimeout(history);
                }
                else {
                    toastManager.add("Error with Facebook login, user not connected to Facebook!", {
                        appearance: 'error'
                    });
                    AuthenticationService.goBackAfterTimeout(history);
                }
            }
        );
    }

    function handleFacebookRegistration() {
        if (window.FB) {
            window.FB.api('/me?fields=name,email,first_name,last_name', (response) => {
                if (!response.email) {
                    toastManager.add("Please register with Google or by completing the form.", {
                        appearance: 'error'
                    });
                    setState({...state, loading: false, modalShown: false});
                    AuthenticationService.goBackAfterTimeout(history);
                    return ;
                }

                const facebookResponse = {
                    email: response.email,
                    first_name: response.first_name,
                    last_name: response.last_name,
                    accessToken: state.fbToken
                };

                var userData = { // user id to be added (for future update user endpoint)
                    user_agreement: true
                };

                AuthenticationService.decideFacebookRegistration(facebookResponse, state.alreadyRegistered, userData,
                    (response) => {
                        props.saveUserActivationData(response.data.user_id, response.data.token, response.data.level);
                        history.push('/surveys');
                    },
                    (error) => {
                        toastManager.add("Error occurred while trying to register user using Facebook!", {
                            appearance: 'error'
                        });
                        AuthenticationService.goBackAfterTimeout(history);
                    }
                );
            });
        } else {
            history.goBack();
        }
    }

    return (
        <section className="confirm-account">
            <div className="container">
                <TermsAndPrivacyModal modalShown={state.modalShown} closeModal={closeAgreementModal} agreementConfirmFunction={handleFacebookRegistration}/>
                <h2 className="pt-xlg pb-xl">Facebook Login...</h2>
                {
                    state.loading && <LoadingIndicator/>
                }
            </div>
        </section>
    );
}

const mapDispatchToProps = {saveUserActivationData};

export default connect(null, mapDispatchToProps)(withRouter(withToastManager(FacebookAuthComponent)));